import '.h{width:100%;}.ssr-plugin'
import { CSSProperties } from 'react'
import { Slider } from './Slider.js'
import type { RGB } from './utils.js'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { styled, Style } from 'inlines'

export const HueSlider = ({
  hue,
  onChange,
  style,
}: {
  hue: RGB
  onChange: (hue: RGB) => void
  style?: CSSProperties
}) => {
  const max = 255 * 6 - 1
  const [r, g, b] = hue
  let value = 0

  if (r === 255) {
    value = b === 0 ? g : 255 * 5 + (255 - b) + g
  } else if (g === 255) {
    value = 255 + (255 - r) + b
  } else if (b === 255) {
    value = 255 * 3 + (255 - g) + r
  }

  return (
    <styled.div className="h"
      style={{
        border: `1px solid ${colors.neutral20Adjusted}`,
        borderRadius: radius[8],
        ...style,
      }}
    >
      <Slider
        value={value}
        max={max}
        onChange={(n: number) => {
          let hue
          if (n === max) {
            hue = [255, 0, 1]
          } else if (n < 255) {
            hue = [255, n, 0]
          } else if (n < 255 * 2) {
            hue = [255 - (n % 255), 255, 0]
          } else if (n < 255 * 3) {
            hue = [0, 255, n % 255]
          } else if (n < 255 * 4) {
            hue = [0, 255 - (n % 255), 255]
          } else if (n < 255 * 5) {
            hue = [n % 255, 0, 255]
          } else {
            hue = [255, 0, 255 - (n % 255)]
          }
          onChange(hue as [number, number, number])
        }}
        style={{
          background:
            'linear-gradient(to right, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%)',
        }}
      />
    </styled.div>
  )
}
